export const beautyProfileInfo = [
	{
		id: '1',
		profileType: '피부 고민',
		profileName: '각질',
	},
	{
		id: '2',
		profileType: '피부 고민',
		profileName: '탄력',
	},
	{
		id: '3',
		profileType: '피부 고민',
		profileName: '아토피',
	},
	{
		id: '4',
		profileType: '피부 고민',
		profileName: '트러블',
	},
	{
		id: '5',
		profileType: '피부 고민',
		profileName: '속건조',
	},
	{
		id: '6',
		profileType: '피부 고민',
		profileName: '모공',
	},
	{
		id: '7',
		profileType: '피부 고민',
		profileName: '홍조',
	},
	{
		id: '8',
		profileType: '피부 고민',
		profileName: '피지',
	},
	{
		id: '9',
		profileType: '피부 고민',
		profileName: '잡티',
	},
	{
		id: '10',
		profileType: '피부 고민',
		profileName: '해당없음',
	},
	{
		id: '11',
		profileType: '두피 타입',
		profileName: '건성두피',
	},
	{
		id: '12',
		profileType: '두피 타입',
		profileName: '지성두피',
	},
	{
		id: '13',
		profileType: '두피 타입',
		profileName: '민감성두피',
	},
	{
		id: '14',
		profileType: '두피 타입',
		profileName: '트러블두피',
	},
	{
		id: '15',
		profileType: '모발 타입',
		profileName: '건성모',
	},
	{
		id: '16',
		profileType: '모발 타입',
		profileName: '지성모',
	},
	{
		id: '17',
		profileType: '모발 타입',
		profileName: '손상모',
	},
	{
		id: '18',
		profileType: '모발 타입',
		profileName: '탈모',
	},
	{
		id: '19',
		profileType: '퍼스널 컬러',
		profileName: '봄웜톤',
	},
	{
		id: '20',
		profileType: '퍼스널 컬러',
		profileName: '여름쿨톤',
	},
	{
		id: '21',
		profileType: '퍼스널 컬러',
		profileName: '가을웜톤',
	},
	{
		id: '22',
		profileType: '퍼스널 컬러',
		profileName: '겨울쿨톤',
	},
	{
		id: '23',
		profileType: '퍼스널 컬러',
		profileName: '모름',
	},
];

export const beautyProfileMap = beautyProfileInfo.reduce((acc, cur) => {
	acc[cur.id] = cur.profileName;
	return acc;
}, {});

export const beautyProfileTypeList = beautyProfileInfo.reduce((acc, cur) => {
	const id = cur.id;
	const type = cur.profileType;
	const profileName = cur.profileName;

	const targetIdx = acc.findIndex(item => item.type === type);

	const obj = {
		id,
		value: profileName,
	};

	if (targetIdx >= 0) {
		acc[targetIdx].list.push(obj);
		acc[targetIdx].idList.push(id);
		acc[targetIdx].idMap[id] = profileName;
	} else {
		acc.push({
			type,
			list: [obj],
			idList: [id],
			idMap: { [id]: profileName },
		});
	}
	return acc;
}, []);

export const exceptUserTypeList = [
	{ value: '블랙리스트 제외', id: 'isBlack' },
	{ value: '블라인드유저 제외', id: 'isBlind' },
	{ value: '당첨대기유저 제외', id: 'isPrizeWaiting' },
];

export const skinTypeList = [
	{ value: '건성', id: '8' },
	{ value: '지성', id: '9' },
	{ value: '중성', id: '10' },
	{ value: '복합성', id: '11' },
	{ value: '민감성', id: '12' },
	{ value: '설정안함', id: '13' },
];

export const exceptBrandCheckList = [
	{ value: '동일 브랜드 재당첨 제외', id: 'true' },
];

export const genderList = [
	{ value: '여자', id: '7' },
	{ value: '남자', id: '6' },
	{ value: '설정안함', id: '8' },
];

export const searchIncludeFlagList = [
	{ id: 'true', name: '포함' },
	{ id: 'false', name: '일치' },
];

export const createDateTypeCdList = [
	{ value: '일', id: '1' },
	{ value: '개월', id: '2' },
	{ value: '년', id: '3' },
];

export const reviewDateTypeCdList = [
	{ value: '일', id: '1' },
	{ value: '개월', id: '2' },
	{ value: '년', id: '3' },
];

export const gradeList = [
	{ id: '0', name: '그린', color: 'green' },
	{ id: '-1', name: '옐로우', color: 'orange' },
	{ id: '-2', name: '레드', color: 'red' },
	{ id: '-3', name: '블랙', color: 'black' },
];

export const prizeTypeCdList = [
	{ value: '모든 참여자', id: '03' },
	{ value: '당첨 수 0', id: '01' },
	{ value: '당첨 1회 이상', id: '02' },
];

export const eventTypeList = [
	{ value: '전체', id: null },
	{ value: '글픽존', id: '1' },
	{ value: '평가단', id: '2' },
	{ value: '스토어', id: '3' },
	{ value: '샘플링', id: '4' },
	{ value: '설문단', id: '5' },
];

export const isPickpleList = [
	{ value: '전체', id: null },
	{ value: 'Y', id: true },
	{ value: 'N', id: false },
];

export const isCertificationList = [
	{ id: null, value: '전체' },
	{ id: 'false', value: '미인증' },
	{ id: 'true', value: '인증' },
];

export const reviewerGradeList = [
	{ value: 'master', label: 'Lv5 마스터' },
	{ value: 'expert', label: 'Lv4 엑스퍼트' },
	{ value: 'collector', label: 'Lv3 콜렉터' },
	{ value: 'explorer', label: 'Lv2 익스플로러' },
	{ value: 'beginner', label: 'Lv1 비기너' },
];

export const instaCateList = [
	{ id: 'default', txt: '기본' },
	{ id: 'multi', txt: '멀티' },
	{ id: 'supporters', txt: '서포터즈' },
	{ id: 'skincare', txt: '스킨케어' },
	{ id: 'tint', txt: '색조' },
	{ id: 'life', txt: '라이프' },
	{ id: 'baby', txt: '베이비' },
	{ id: 'black', txt: '블랙' },
];

export const orderList = [
	{ value: '최근참여순', id: '1' },
	{ value: '빠른참여순', id: '2' },
	{ value: '당첨적은순', id: '3' },
	{ value: '당첨많은순', id: '4' },
	{ value: '리뷰많은순', id: '5' },
	{ value: '리뷰적은순', id: '6' },
	{ value: '당첨오래된순', id: '7' },
];

export const qnaReportType = {
	q: {
		refType: 'qna',
		label: '질문',
		link: '/qna/q',
		api: '/qna',
	},
	a: {
		refType: 'qna_reply',
		label: '답변',
		link: '/qna/a',
		api: '/qna/reply',
		parentType: 'q',
		parentRefType: 'qna',
	},
	c: {
		refType: 'qna_reply',
		label: '댓글',
		link: '/qna/c',
		api: '/qna/reply',
		parentType: 'c',
		parentRefType: 'parent',
	},
};

export const contactChannelList = [
	{ value: '인스타그램', label: '인스타그램' },
	{ value: '페이스북', label: '페이스북' },
	{ value: '포털검색', label: '포털 검색' },
	{ value: '뉴스레터', label: '뉴스레터' },
	{ value: '기타', label: '기타' },
];
